import * as React from 'react';
import type { Days } from '../../app/ApiGen';
import { DateSelectionMenu, type MenuOption } from '../SelectionMenu';

const options: MenuOption<Days>[] = [
  { label: 'Last 7 days', value: 7 },
  { label: 'Last 14 days', value: 14 },
  { label: 'Last 30 days', value: 30 },
];

interface DateLookbackSelectProps {
  selected: Days;
  onSelect: (id: Days) => void;
}

export const DateLookbackSelect: React.FC<DateLookbackSelectProps> = ({ selected, onSelect }) => (
  <DateSelectionMenu defaultValue={selected} options={options} onChange={(e) => onSelect(e.target.value as Days)} />
);
